import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Mail, Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "@/constants/contact";

const SUPPORT_PHONE = CONTACT.phone;
const SUPPORT_PHONE_DISPLAY = CONTACT.phoneDisplay;
const SUPPORT_EMAIL = CONTACT.email;
const WHATSAPP_URL = CONTACT.whatsapp();

const FAQS = [
  { q: "What documents do I need?", a: "Valid driving license, government photo ID, and a credit/debit card for the refundable deposit." },
  { q: "Is the helmet included?", a: "Yes. We provide one ISI-certified helmet free with every booking. Additional helmets can be added at checkout." },
  { q: "What happens if I'm late returning the vehicle?", a: "A late fee equivalent to your hourly rate applies. We'll send you reminders 1 hour before drop time." },
  { q: "Is insurance included?", a: "All rides come with third-party and rider personal accident insurance up to ₹5,00,000." },
  { q: "Can I cancel a booking?", a: "Yes, cancellations are free up to 6 hours before pickup. Within 6 hours a small fee applies." },
];

const CHANNELS = [
  {
    icon: Phone,
    label: "Call us",
    value: SUPPORT_PHONE_DISPLAY,
    href: `tel:+91${SUPPORT_PHONE}`,
    testid: "support-phone",
  },
  {
    icon: MessageCircle,
    label: "WhatsApp",
    value: SUPPORT_PHONE_DISPLAY,
    href: WHATSAPP_URL,
    testid: "support-whatsapp",
    external: true,
  },
  {
    icon: Mail,
    label: "Email",
    value: SUPPORT_EMAIL,
    href: `mailto:${SUPPORT_EMAIL}`,
    testid: "support-email",
  },
];

const Support = () => (
  <div className="min-h-screen bg-[#F8F9FA]">
    <Navbar />
    <div className="max-w-5xl mx-auto px-5 md:px-8 py-20">
      <p className="text-[10px] uppercase tracking-widest font-bold text-[#2D7FF9] font-mono-num">— SUPPORT</p>
      <h1 className="font-display font-extrabold text-5xl md:text-6xl mt-4 tracking-tight">We're here, 24×7.</h1>
      <p className="text-gray-600 mt-4 max-w-xl text-lg">Real humans, real fast. Reach out any time and we'll help you get back on the road.</p>

      <div className="grid sm:grid-cols-3 gap-4 mt-12">
        {CHANNELS.map((c) => (
          <a
            key={c.testid}
            href={c.href}
            {...(c.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            data-testid={c.testid}
            className="card-premium p-6 hover:border-[#3DDC97]/40 transition-colors block"
          >
            <c.icon className="text-[#2D7FF9]" size={20} />
            <p className="text-[10px] uppercase tracking-widest text-gray-500 font-bold mt-4">{c.label}</p>
            <p className="font-display font-bold text-lg mt-1 font-mono-num">{c.value}</p>
          </a>
        ))}
      </div>

      <div className="mt-16">
        <h2 className="font-display font-extrabold text-3xl tracking-tight">FAQs</h2>
        <div className="mt-6 space-y-3">
          {FAQS.map((f, i) => (
            <details key={i} className="card-premium p-6 group" data-testid={`faq-${i}`}>
              <summary className="font-display font-bold text-lg cursor-pointer flex items-center justify-between">
                {f.q}
                <span className="text-[#3DDC97] group-open:rotate-45 transition-transform">+</span>
              </summary>
              <p className="text-gray-600 mt-3 leading-relaxed">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </div>
    <Footer />
  </div>
);

export default Support;
